import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import { getEnvVariables } from "../../../../env";

const MIXPANEL_TOKEN = getEnvVariables().MIXPANEL_TOKEN;

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn("Mixpanel token is missing! Check your .env file.");
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: {
      click: false,
      input: false,
      scroll: false,
      submit: false,
      capture_text_content: false,
      pageview: false,
    },
  });
};

const MixpanelInit = () => {
  useEffect(() => {
    initMixpanel();
  }, []);

  return null;
};

export default MixpanelInit;
